module.exports = __webpack_public_path__ + "static/media/btn_close.e3bd6550.svg";